import React, { useEffect, useState } from 'react';

/* External */
import WarningIcon from '@material-ui/icons/Warning';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { makeStyles } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/core';

/* Project */
import { selectState, actionProps } from 'utils/reduxActions';
import { homeActions } from 'screens/Home/reducer';
import { appActions } from 'commons/reducer';
import { ReactReduxContext } from 'config/configureStore';
import { clone, falsy, onChangeFnc, truthty } from 'utils/functions';
import { processActions } from 'screens/Process/reducer';
import { useAutomation } from 'utils/hooks/useAutomationPermission';
import connectSaga from 'utils/saga';
import ProcessComponent from './components';
import saga from './saga';
import styles from './styles';

const useStyles = makeStyles(styles);

function Process(props) {
  const { t } = useTranslation();
  const { hasAutomation } = useAutomation();
  const [dialButtonOpen, setDialButtonOpen] = useState(false);
  const [process, setProcess] = useState({});
  const [qrCode, setQrCode] = useState('');

  const {
    match,
    actions,
    objects,
    formControls,
    lotId,
    invalidControls,
    formIsOpen,
    device,
    account,
    processResources,
    history,
    infoLot,
    usedLot,
    stopLoading,
    delete: deleteProp,
  } = props;

  const { params } = match;

  useEffect(() => {
    if (params.id) {
      actions.getStateFromApi(params.id);
      actions.loadProcessResources(params.id);
    }
  }, [actions, params.id]);

  useEffect(() => {
    setProcess(objects.processes[Number(params.id)] || {});
  }, [objects, params.id]);

  useEffect(() => {
    if (params.id) {
      actions.loadProcessResources(params.id);
    }
  }, [
    objects.procceses,
    Object.values(objects.processEquipments).length,
    Object.values(objects.processStaffLines).length,
    Object.values(objects.supplyLines).length,
  ]);

  const speedDialToggle = () => {
    setDialButtonOpen(!dialButtonOpen);
  };

  function toggleForm(event) {
    if (dialButtonOpen) {
      speedDialToggle();
    }

    const { module, id } = event.currentTarget.dataset;

    let lot = {};
    let departureLot = {};

    if (module) {
      let lots = Object.values(objects.lots).filter((lotIt) => lotIt.destinyProcessId === lotId);

      if (id) {
        lots = Object.values(objects.lots).filter((lotIt) => lotIt.id === Number(id));
      }

      lot = lots[lots.length - 1] || {};

      let departureLots = Object.values(objects.lots).filter(
        (dLot) => dLot.originProcessId === lotId,
      );

      if (id) {
        departureLots = Object.values(objects.lots).filter((dLot) => dLot.id === Number(id));
      }
      departureLot = departureLots[departureLots.length - 1] || {};

      actions.changeControls(
        module,
        {
          fruitId: lot.fruitId || '',
          varietyId: lot.varietyId || '',
          productId: departureLot.productId || '',
          packagingTypeId: departureLot.packagingTypeId || '',
          warehouseId: departureLot.warehouseId || '',
          packagingQuantity: departureLot.packagingQuantity || '',
          customField: departureLot.customField || '',
          processDate: departureLot.processDate || '',
          inboundLotId: departureLot.inboundLotId || '',
        },
        'invalidControls',
      );
    }

    if (id) {
      actions.toggleForm(module, lot);
    } else {
      actions.toggleForm(module);
    }
  }

  function changeControls(event, date, withModule = true) {
    onChangeFnc(actions.changeControls, event, date, withModule);
  }

  function submitStaff() {
    if (falsy(formControls.staff.employeeIds)) {
      actions.setInvalidControls('staff', {
        employeeIds: falsy(formControls.staff.employeeIds),
      });
    } else {
      actions.addProcessStaff(process.id, formControls.staff.employeeIds);
    }
  }

  function submitProcessEquipments() {
    if (falsy(formControls.processEquipments.equipmentIds)) {
      actions.setInvalidControls('processEquipments', {
        equipmentIds: falsy(formControls.processEquipments.equipmentIds),
      });
    } else {
      actions.addProcessEquipments(process.id, formControls.processEquipments.equipmentIds);
    }
  }

  function submitLot() {
    const { quantity, packagingTypeId, packagingQuantity } = formControls.departure;
    let totalWeight = 0;
    if (truthty(quantity) && truthty(packagingTypeId) && truthty(packagingQuantity)) {
      totalWeight = quantity - objects.packagingTypes[packagingTypeId].weight * packagingQuantity;
    }

    if (
      falsy(formControls.departure.productId) ||
      falsy(formControls.departure.varietyId) ||
      falsy(formControls.departure.quantity) ||
      falsy(formControls.departure.packagingQuantity) ||
      falsy(formControls.departure.packagingTypeId) ||
      totalWeight <= 0
    ) {
      actions.setInvalidControls('departure', {
        productId: falsy(formControls.departure.productId),
        varietyId: falsy(formControls.departure.varietyId),
        quantity: falsy(formControls.departure.quantity),
        packagingQuantity: falsy(formControls.departure.packagingQuantity),
        packagingTypeId: falsy(formControls.departure.packagingTypeId),
      });
    } else {
      actions.addDeparture(
        process.id,
        formControls.departure,
        totalWeight,
        device,
        account?.zplCustomCode,
      );
    }
  }

  function submitSupplyProduct() {
    const { supplyProductId, warehouseId, quantity, purchaseId } = formControls.supplyProducts;

    const inventoryLine =
      truthty(supplyProductId) && truthty(warehouseId)
        ? objects.supplyProducts[supplyProductId].inventoryLine(warehouseId, purchaseId)
        : {};

    const stock =
      truthty(supplyProductId) && truthty(warehouseId)
        ? inventoryLine.initial + inventoryLine.inputs - inventoryLine.outputs
        : 0;

    if (falsy(supplyProductId) || falsy(warehouseId) || falsy(quantity) || stock < quantity) {
      actions.setInvalidControls('supplyProducts', {
        supplyProductId: falsy(supplyProductId),
        warehouseId: falsy(warehouseId),
        quantity: falsy(quantity) || stock < quantity,
      });
    } else {
      actions.addSupplyLine(process.id, formControls.supplyProducts, inventoryLine);
    }
  }

  function submitEntry(lotIdEntry) {
    const entryLotId = formControls.entry.lotId || lotIdEntry;
    if (!entryLotId) {
      actions.setInvalidControls('entry', {
        productId: entryLotId,
      });
    } else {
      actions.addEntry(entryLotId, process.id);
    }
  }

  function submitDelete() {
    const { actionFnc, id } = deleteProp;
    actions[actionFnc](id, process.id);
  }

  function printFnc(lotIdPrint) {
    return () => {
      if (hasAutomation) {
        actions.reprintAutomationLabels([lotIdPrint], account?.id, device);
      } else {
        const labelData = {
          lotIds: [lotIdPrint],
          accountId: account?.id,
          forcePaksLabel: true,
        };
        actions.printLabel(device, labelData);
      }
    };
  }

  const printFncPaks = (lotIdPrint, numPaks) => {
    const lotIds = [lotIdPrint];
    if (hasAutomation) {
      actions.reprintAutomationLabels(lotIds, account?.id, device, numPaks);
    } else {
      actions.infoPaksToPrint(account?.id, lotIds, numPaks, device);
    }
  };

  function printAllFnc(lotIds) {
    return () => {
      if (!truthty(lotIds)) {
        actions.setError(t('No paks found'));
        return;
      }

      if (hasAutomation) {
        actions.reprintAutomationLabels(lotIds, account?.id, device);
      } else {
        const labelData = { lotIds, accountId: account?.id, forcePaksLabel: true };
        actions.printLabel(device, labelData);
      }
    };
  }

  function qrReader(event, qrCodeReader) {
    setQrCode(truthty(event.target) ? event.target.value : qrCodeReader);
  }

  function changeWeight(weight) {
    actions.changeControls('departure', { quantity: weight }, { quantity: false });
  }

  function onBackAction() {
    if (window.history.length > 1) {
      history.goBack();
    } else {
      history.push('/processes');
    }
  }

  const processStaffLines = Object.values(objects.processStaffLines).filter(
    (line) => line.processId === process.id,
  );

  const employeeOptions = Object.values(objects.employees)
    .filter((emp) => !processResources.usedEmployeesIds.includes(emp.id))
    .map((emp) => {
      const used = processResources.usedEmployeesIds.includes(emp.id);
      const toolTip = used && t('process.personnelInOtherProcess');
      const endIcon = used && <WarningIcon style={{ color: '#ffc107' }} />;
      return {
        label: emp.entity().name,
        value: emp.id,
        toolTip,
        endIcon,
      };
    });

  const equipmentOptions = Object.values(objects.equipments)
    .filter((emp) => !processResources.usedEquipmentsIds.includes(emp.id))
    .map((equipment) => ({ label: equipment.name, value: equipment.id }));

  const classes = useStyles();

  // eslint-disable-next-line react/destructuring-assignment
  const [role] = Object.values(props.role);
  const multipleLotsProcess =
    truthty(process) &&
    (hasAutomation
      ? process.ProcessType?.allowMultipleLots
      : process.processType().allowMultipleLots);
  const uniqueLot =
    !multipleLotsProcess && lotId
      ? Object.values(objects.lots).filter((lot) => lot.destinyProcessId === process.id)[0] || {}
      : {};

  // departureForm
  const { quantity, packagingTypeId, packagingQuantity } = formControls.departure;
  let totalWeight = 0;
  if (truthty(quantity) && truthty(packagingTypeId) && truthty(packagingQuantity)) {
    totalWeight = quantity - objects.packagingTypes[packagingTypeId].weight * packagingQuantity;
  }

  function closeProcess(id, date) {
    actions.closeProcess(id, date);
  }

  const isAdmin = role && objects.roles[role].name === 'admin';
  const resultPaks = Object.values(objects.lots).filter(
    (lot) => lot.originProcessId === process.id,
  );
  const entriesPaks = Object.values(objects.lots).filter(
    (lot) => lot.destinyProcessId === process.id,
  );

  function toggleDelete(event) {
    if (event.currentTarget.dataset.module === 'deleteEntry' && isAdmin) {
      if (
        entriesPaks.length > 1 &&
        resultPaks.length > 0 &&
        resultPaks.some((lot) => lot.destinyProcessId !== null)
      ) {
        actions.setError(t('process.cannotDeletePaksOutputInOtherProcess'));
      } else if (entriesPaks.length === 1 && resultPaks.length > 0) {
        actions.setError(t('process.cannotDeletePaksEmptyEntries'));
      } else if (
        entriesPaks.length > 1 &&
        resultPaks.length > 0 &&
        !resultPaks.some((lot) => lot.destinyProcessId !== null)
      ) {
        actions.toggleDelete(event.currentTarget.dataset.module, event.currentTarget.dataset.id);
      } else if (resultPaks.length === 0) {
        actions.toggleDelete(event.currentTarget.dataset.module, event.currentTarget.dataset.id);
      }
    } else if (
      !isAdmin &&
      event.currentTarget.dataset.module === 'deleteEntry' &&
      resultPaks.length > 0
    ) {
      actions.setError(t('process.cannotDeletePaksAssignedOutput'));
    } else {
      actions.toggleDelete(event.currentTarget.dataset.module, event.currentTarget.dataset.id);
    }
  }

  return (
    <ProcessComponent
      classes={classes}
      speedDialToggle={speedDialToggle}
      dialButtonOpen={dialButtonOpen}
      process={process}
      hasAutomation={hasAutomation}
      processStaffLines={processStaffLines}
      objects={objects}
      toggleForm={toggleForm}
      formControls={formControls}
      invalidControls={invalidControls}
      formIsOpen={formIsOpen}
      changeControls={changeControls}
      changeControlsNeedsEvent
      submitStaff={submitStaff}
      submitProcessEquipments={submitProcessEquipments}
      employeeOptions={employeeOptions}
      equipmentOptions={equipmentOptions}
      toggleDelete={toggleDelete}
      // eslint-disable-next-line react/destructuring-assignment
      delete={props.delete}
      submitDelete={submitDelete}
      submitLot={submitLot}
      submitEntry={submitEntry}
      submitSupplyProduct={submitSupplyProduct}
      printFnc={printFnc}
      printFncPaks={printFncPaks}
      // printPakLabels={printPakLabels}
      printAllFnc={printAllFnc}
      lotId={lotId}
      qrReader={qrReader}
      onChangeFnc={actions.changeControls}
      qrCode={qrCode}
      changeWeight={changeWeight}
      multipleLotsProcess={multipleLotsProcess}
      uniqueLot={uniqueLot}
      role={role || {}}
      totalWeight={totalWeight}
      closeProcess={closeProcess}
      toggleClose={actions.toggleClose}
      processResources={processResources}
      onBackAction={onBackAction}
      isAdmin={isAdmin}
      infoEntryLots={actions.infoEntryLots}
      infoLot={infoLot}
      usedLot={usedLot}
      actions={actions}
      stopLoading={stopLoading}
    />
  );
}

const withSaga = connectSaga({ key: 'sagaProcess', saga });

const withConnect = connect(
  selectState(
    'process.invalidControls',
    'process.formControls',
    'process.deleteIsOpen',
    'process.toDeleteId',
    'process.formIsOpen',
    'process.toEditId',
    'process.delete',
    'process.lotId',
    'process.edit',
    'process.processResources',
    'app.objects',
    'app.device',
    'app.role',
    'app.account',
    'process.infoLot',
    'process.usedLot',
    'process.stopLoading',
  ),
  actionProps(clone(clone.OBJECT, homeActions, processActions, appActions)),
  null,
  { context: ReactReduxContext },
);

export default compose(withStyles(styles), withRouter, withConnect)(withSaga(Process));
